import React from 'react'
import './icons.scss'

const LuxCodeIcon = (props: {
    text: string
    color?: string
    classes?: string
}) => {
    const { text, color, classes } = props

    return (
        <span
            className={`wardrobe-texticon ${classes ? classes : ''}`}
            style={{
                backgroundColor: color ? color : 'var(--lux-primary)',
            }}>
            <div>{text}</div>
        </span>
    )
}

export default LuxCodeIcon
